// extracted by mini-css-extract-plugin
export var aniSpin = "H_d";
export var contact = "H_bz";
export var edge = "H_bt";
export var el = "H_b";
export var heading = "H_T";
export var illustration = "H_bw";
export var inner = "H_r";
export var notes = "H_bv";
export var social = "H_bx";
export var socialLink = "H_by";